package org.catharsis.spendtel.feature.presentation

import org.catharsis.spendtel.core.api.ExpenseReportRepo
import org.catharsis.spendtel.core.arch.MviViewModel
import org.catharsis.spendtel.core.arch.ViewEffect
import org.catharsis.spendtel.core.arch.ViewEvent
import org.catharsis.spendtel.core.arch.ViewState
import org.catharsis.spendtel.feature.share.PublicShareDocument

class PublicShareViewModel(
    private val shareId: String,
    private val expenseReportRepo: ExpenseReportRepo,
) : MviViewModel<PublicShareEvent, PublicShareState, PublicShareEffect>(
    initialState = PublicShareState(shareId = shareId),
) {
    init {
        launch { loadShare() }
    }

    override fun receiveEvent(event: PublicShareEvent) {
        when (event) {
            PublicShareEvent.OnRefresh -> launch { loadShare() }
        }
    }

    private suspend fun loadShare() {
        setState { copy(isLoading = true, error = null) }
        val share = expenseReportRepo.getPublicShare(shareId)
        setState {
            copy(
                isLoading = false,
                share = share,
                error = if (share == null) "This shared story is unavailable or has expired." else null,
            )
        }
    }
}

data class PublicShareState(
    val shareId: String,
    val isLoading: Boolean = true,
    val share: PublicShareDocument? = null,
    val error: String? = null,
) : ViewState

sealed class PublicShareEvent : ViewEvent {
    data object OnRefresh : PublicShareEvent()
}

sealed class PublicShareEffect : ViewEffect
